module.exports = __webpack_public_path__ + "static/img/btn_99_1.7057b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/btn_99_1.png
// module id = /jqj
// module chunks = 0